import { API_URL } from "../config/connect";

const authHeaders = (json = false) => {
  const token = localStorage.getItem("google_id_token");
  const h = { Authorization: `Bearer ${token}` };
  if (json) h["Content-Type"] = "application/json";
  return h;
};

const parseError = async (res, fallback) => {
  try {
    const d = await res.json();
    if (typeof d?.detail === "string") return d.detail;
  } catch {}
  return fallback;
};

const request = async (url, options, fallback) => {
  const res = await fetch(url, options);
  if (!res.ok) {
    const msg = await parseError(res, fallback);
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return res.json();
};

const BASE = `${API_URL}/api/v1/admin/banners/company`;

export const listCompanyBanners = (status = "all", limit = 200) =>
  request(
    `${BASE}/list?status=${encodeURIComponent(status)}&limit=${limit}`,
    { method: "GET", headers: authHeaders() },
    "Не удалось получить список баннеров"
  );

export const listPendingCompanyBanners = (limit = 50) =>
  request(
    `${BASE}/pending?limit=${limit}`,
    { method: "GET", headers: authHeaders() },
    "Не удалось получить список pending баннеров"
  );

export const approveCompanyBanner = (userId) =>
  request(
    `${BASE}/${userId}/approve`,
    { method: "POST", headers: authHeaders() },
    "Не удалось подтвердить баннер"
  );

export const rejectCompanyBanner = (userId, reason) =>
  request(
    `${BASE}/${userId}/reject`,
    {
      method: "POST",
      headers: authHeaders(true),
      body: JSON.stringify({ reason: reason || null }),
    },
    "Не удалось отклонить баннер"
  );

export const uploadCompanyBanner = (userId, file) => {
  const fd = new FormData();
  fd.append("banner", file);
  return request(
    `${BASE}/${userId}/upload`,
    { method: "POST", headers: authHeaders(), body: fd },
    "Не удалось загрузить баннер"
  );
};

export const deleteCompanyBanner = (userId, scope = "all") =>
  request(
    `${BASE}/${userId}?scope=${encodeURIComponent(scope)}`,
    { method: "DELETE", headers: authHeaders() },
    "Не удалось удалить баннер"
  );
